const atsBoxShadows = {
  'ats-shadow-1':
    ' 0px 3px 8px 0px #ABABAB1A, 0px 14px 14px 0px #ABABAB17, 0px 31px 19px 0px #ABABAB0D, 0px 55px 22px 0px #ABABAB03, 0px 86px 24px 0px #ABABAB00',
  'ats-shadow-2':
    '0px 1px 3px 0px #605AFB1A inset,0px 6px 6px 0px #605AFB17 inset,0px 13px 8px 0px #605AFB0D inset,0px 23px 9px 0px #605AFB03 inset,0px 36px 10px 0px #605AFB00 inset',
  'ats-shadow-3':
    '2px 4px 10px 0px #D6D6D61A,8px 17px 19px 0px #D6D6D617,18px 38px 25px 0px #D6D6D60D,32px 68px 30px 0px #D6D6D603;,50px 107px 33px 0px #D6D6D600',
  'drop-shadows-bottom':
    ' 0px 4px 10px 0px #D7DAEB1A, 0px 18px 18px 0px #D7DAEB17, 0px 40px 24px 0px #D7DAEB0D, 0px 71px 29px 0px #D7DAEB03, 0px 111px 31px 0px #D7DAEB00',
  'drop-shadows-top':
    ' 0px -4px 9px 0px #D7DAEB1A, 0px -17px 17px 0px #D7DAEB17, 0px -38px 23px 0px #D7DAEB0D ,0px -68px 27px 0px #D7DAEB03,0px -106px 30px 0px #D7DAEB00',
  'drop-shadows-left':
    ' -11px 0px 25px 0px #D7DAEB1A, -45px 0px 45px 0px #D7DAEB17,-102px 0px 61px 0px #D7DAEB0D, -181px 0px 73px 0px #D7DAEB03, -283px 0px 79px 0px #D7DAEB00',
  'drop-shadows-right':
    ' 4px 0px 10px 0px #D7DAEB1A,18px 0px 18px 0px #D7DAEB17,40px 0px 24px 0px #D7DAEB0D,70px 0px 28px 0px #D7DAEB03,110px 0px 31px 0px #D7DAEB00',
  'inner-shadows-top':
    ' 0px 7px 15px 0px #D7DAEB1A inset ,0px 27px 27px 0px #D7DAEB17 inset,0px 61px 37px 0px #D7DAEB0D inset,0px 108px 43px 0px #D7DAEB03 inset,0px 169px 47px 0px #D7DAEB00 inset',
  'inner-shadows-bottom':
    '0px -6px 14px 0px #D7DAEB1A inset, 0px -25px 25px 0px #D7DAEB17 inset,0px -56px 34px 0px #D7DAEB0D inset,0px -100px 40px 0px #D7DAEB03 inset,0px -157px 44px 0px #D7DAEB00 inset',
  'inner-shadows-left':
    ' 6px 0px 14px 0px #D7DAEB1A inset,26px 0px 26px 0px #D7DAEB17 inset,58px 0px 35px 0px #D7DAEB0D inset,103px 0px 41px 0px #D7DAEB03 inset,162px 0px 45px 0px #D7DAEB00 inset',
  'inner-shadows-right':
    'box-shadow: -7px 0px 15px 0px #D7DAEB1A inset, -27px 0px 27px 0px #D7DAEB17 inset,-62px 0px 37px 0px #D7DAEB0D inset,-110px 0px 44px 0px #D7DAEB03 inset, -172px 0px 48px 0px #D7DAEB00 inset',
  'drop-shadows-bottom-primary':
    ' 0px 4px 10px 0px #797DFF1A, 0px 18px 18px 0px #797DFF17, 0px 40px 24px 0px #797DFF0D, 0px 71px 29px 0px #797DFF03, 0px 111px 31px 0px #797DFF00',
  'drop-shadows-outer-primary':
    '2px 4px 10px 0px #9FAAFF1A,8px 17px 19px 0px #9FAAFF17,18px 38px 25px 0px #9FAAFF0D,32px 68px 30px 0px #9FAAFF03;,50px 107px 33px 0px #9FAAFF00',
  'drop-shadows-outer-secondary':
    ' 0px 1px 2px 0px #CCD0E51A, 0px 4px 4px 0px #CCD0E517, 0px 8px 5px 0px #CCD0E50D, 0px 15px 6px 0px #CCD0E503, 0px 23px 6px #CCD0E500',
  'drop-shadows-bottom-tertiary':
    ' 0px 3px 6px 0px #C7C7C71A, 0px 11px 11px 0px #C7C7C717, 0px 26px 15px 0px #C7C7C70D, 0px 45px 18px 0px #C7C7C703, 0px 71px 20px 0px #C7C7C700',
};

export const boxShadow = {
  light: {
    primary: '0px 4px 12px 6px rgba(46, 47, 48, 0.06)',
    highlight: '0 0 0 2px #8370FD',
  },
  ...atsBoxShadows,
};
